import { useState } from 'react';

export function useContractSaving() {
  const [isSaving, setIsSaving] = useState(false);
  const [isPublishing, setIsPublishing] = useState(false);

  return {
    isSaving, setIsSaving,
    isPublishing, setIsPublishing,
  };
}
